/// <reference types="sharepoint" />
import { Component, AfterViewInit, ChangeDetectorRef, AfterViewChecked ,ViewEncapsulation} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from './front-user/shared/services/authentication.service';
import { Router , NavigationEnd  } from '@angular/router';
import { User } from './front-user/shared/models/user.model';

//******* Localizing Datepicker ***************//

import { GlobalServices } from './shared/services/global.service';
import { Languages } from './shared/models/enums.model';
import { arLocale } from 'ngx-bootstrap/locale';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { CookieService } from 'ngx-cookie-service';

//***************************/
declare global {
  interface Window {
    AngularRoutingAction: () => void;
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None,
})

export class AppComponent {

  title = 'SCAServices';
  currentUser: User;
  cookieValue: string = '';
  public Languages: any = Languages;
  public isLoaderEnabled: boolean = false;
  public historyData = [];
  public myRequestsSearchCriteria = [];
  InvalidDateMessage: string;

  constructor(private translate: TranslateService, private authenticationService: AuthenticationService, private router: Router, private cookieService: CookieService, private localeService: BsLocaleService, public globalSrv: GlobalServices, private cd: ChangeDetectorRef) {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    //translate.get('InvalidDate').subscribe(value => { this.InvalidDateMessage = value; });
    //arLocale.invalidDate = this.InvalidDateMessage;
    defineLocale('ar', arLocale);
    if (this.globalSrv.getLanguage() === Languages.Arabic) {
      translate.setDefaultLang("ar");
      translate.use("ar");
      //localizing datepicker
      this.localeService.use("ar");
    } else {
      translate.setDefaultLang("en");
      translate.use("en");
      //localizing datepicker
      this.localeService.use("en");
    }
  }

  public get IsLoaderEnabled(): boolean {
    if (this.isLoaderEnabled != this.globalSrv.IsLoaderEnabled) {
      setTimeout(() => {
        this.isLoaderEnabled = this.globalSrv.IsLoaderEnabled;
        this.cd.detectChanges();
      });
    }
    return this.isLoaderEnabled;
  }

  useLanguage(language: string) {
    this.translate.use(language);
  }

  // logout() {
  //
  //   this.authenticationService.logout()
  //   .subscribe((data: ResponseObject) => {
  //     //this.authenticationService..subscribe(x => this.currentUser = x);;
  //   });
  //   this.router.navigate(['/login']);
  //   this.authenticationService.refresh();
  // }


  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // console.log('Navigated to route:', event.urlAfterRedirects);
        
          if (typeof window.AngularRoutingAction === 'function') {
          window.AngularRoutingAction();
        } 
        else {
          // console.log('Function still undefined, retrying...');
          setTimeout(this.ngOnInit, 500);
        }

        
      }
    });
  }

}
